//packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Popover,
    OverlayTrigger
} from 'react-bootstrap'

//styles
import './SelectorPopover'

class SelectorPopover extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.element
        ])
    };

    static defaultProps = {};

    render() {
        return (
            <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="right"
                shouldUpdatePosition={true}
                overlay={<Popover id="popover-of-form">{this.props.children}</Popover>}>
                <span className="ir-tooltip"/>
            </OverlayTrigger>
        )
    }
}

export default SelectorPopover



// WEBPACK FOOTER //
// ./src/components/Modules/Selector/SelectorPopover/SelectorPopover.js